import { FC, Fragment } from "react";
import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import SmsFailedRoundedIcon from "@mui/icons-material/SmsFailedRounded";
import { ContainedButton } from "../../styled/contained-button";

const rowStyles: React.CSSProperties = {
  textAlign: "center",
  padding: "10px",
  fontWeight: "bold",
};

interface IBackup {
  date: string;
  handleBackupAction: () => void;
  handleDownloadAction: () => void;
  status: boolean;
  loading: boolean;
}

export const DashboardBackup: FC<IBackup> = ({
  date,
  handleBackupAction,
  handleDownloadAction,
  status,
  loading,
}) => {
  return (
    <Fragment>
      <Typography variant="h6" mt={5} mb={3}>
        Backup
      </Typography>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={rowStyles}>Vorname</TableCell>
            <TableCell style={rowStyles}>Date</TableCell>
            <TableCell style={rowStyles}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Grid
                  container
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress size={50} />
                </Grid>
              </TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell align="center">Backup</TableCell>
              <TableCell align="center">{date}</TableCell>
              <TableCell align="center">
                <Grid container justifyContent="center" alignContent="center">
                  {status ? (
                    <CheckCircleRoundedIcon
                      style={{ color: "green", marginRight: "10px" }}
                    />
                  ) : (
                    <SmsFailedRoundedIcon
                      style={{ color: "red", marginRight: "10px" }}
                    />
                  )}
                  <Typography>{status ? "Success" : "Failed"}</Typography>
                </Grid>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Grid container justifyContent="center" alignContent="center" gap={2}>
        <Grid item mt={5}>
          <ContainedButton onClick={handleBackupAction} disabled={loading}>
            Backup
          </ContainedButton>
        </Grid>
        <Grid item mt={5}>
          <ContainedButton
            onClick={handleDownloadAction}
            disabled={loading || !status}
          >
            Herunterladen
          </ContainedButton>
        </Grid>
      </Grid>
    </Fragment>
  );
};
